import { useState } from "react";
import { submitForm } from "./submitForm";

/** Shared submit/error/success state for the 4 intake forms. */
export function useSubmission({ collectionName, storageFolder }) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const submit = async (fields, files) => {
    setError("");
    setSubmitting(true);
    try {
      await submitForm({ collectionName, storageFolder, fields, files });
      setSuccess(true);
    } catch (e) {
      setError(e.message || "Something went wrong submitting the form. Please try again.");
    }
    setSubmitting(false);
  };

  return { submitting, error, setError, success, submit };
}
